export default __webpack_public_path__ + "static/media/Mais4Icon.128d7c8c.svg";